/**
 * @author 吴光富
 * @name 客户端分享模块
 * @description
 *   兼容随手记客户端分享、卡牛客户端分享
 */

import useragent from '@common/useragent'
import toast from '@common/toast'
import { urlParams } from '@common/format'
import { call, uriSuishouji, uriSuiguanjia } from './bridge'
// import { splice } from './version'

const completeUrl = (url) => {
  const a = document.createElement('a')
  a.href = url
  return a.href
}

const requestShare = (
  {
    title = '随手理财',
    content = '值得信赖的投资理财平台',
    url = location.href,
    img,
  } = {},
  callback = (data) => { console.log(data) }
) => {
  // 在分享链接中加入分享标识
  const absoluteUrl = urlParams(completeUrl(url), { from: 'share' })
  const shareCb = (data) => {
    let parseData = data
    try {
      parseData = JSON.parse(data)
    } catch (e) {
      console.log(e)
    }

    let result
    let type
    if (useragent.isSuishouji) {
      result = parseData.result
      type = parseData.shareType.toLowerCase()
    } else if (useragent.isKaniu) {
      const map = {
        0: 'success',
        1: 'error',
        2: 'cancel'
      }
      result = map[parseData.resultCode]
      type = parseData.targetApp
    }

    // result: success, error, cancel；shareType: qq,qzone,weixin,pyq,sina_weibo,link,message
    callback({ result, type })
  }

  const params = { title, content, url: absoluteUrl }

  if (useragent.isSuishouji) {
    // 在随手记客户端
    params.img = (img && completeUrl(img)) || 'https://marketres.feidee.com/act/common/logo.png'
    call(uriSuishouji('requestShare', params, 'shareCb'), 'shareCb', shareCb)
  } else if (useragent.isKaniu) {
    // 在卡牛客户端
    img && (params.img = completeUrl(img))
    call(urlParams('cardniu://app/webview/share', params), 'onShareResult', shareCb)
  } else if (useragent.isSuiguanjia) {
    img && (params.img = completeUrl(img))
    call(uriSuiguanjia('sgj://app/share', {
      config: params
    }, 'onShareResult'), 'onShareResult', shareCb)
  } else {
    // 其他客户端
    toast('您可以复制链接分享给朋友们')
  }
}

export default requestShare



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/requestShare.js